var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"template-image",attrs:{"src":_vm.templateImage,"alt":"template"}})
}
var staticRenderFns = []

export { render, staticRenderFns }